
// @ts-nocheck
import locale_de_46json_810bbc35 from "#nuxt-i18n/810bbc35";
import locale_en_46json_121154db from "#nuxt-i18n/121154db";

export const localeCodes =  [
  "de",
  "en"
]

export const localeLoaders = {
  de: [
    {
      key: "locale_de_46json_810bbc35",
      load: () => Promise.resolve(locale_de_46json_810bbc35),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_121154db",
      load: () => Promise.resolve(locale_en_46json_121154db),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de",
      name: "DE",
      iso: "de-DE",
      dir: "ltr",
      files: [
        {
          path: "/home/yyi/ws-projekte/ws-website-2.0/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      name: "EN",
      iso: "en-US",
      dir: "ltr",
      files: [
        {
          path: "/home/yyi/ws-projekte/ws-website-2.0/i18n/locales/en.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: true,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://walbert-schmitz.de",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de",
    name: "DE",
    iso: "de-DE",
    dir: "ltr",
    files: [
      {
        path: "/home/yyi/ws-projekte/ws-website-2.0/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "EN",
    iso: "en-US",
    dir: "ltr",
    files: [
      {
        path: "/home/yyi/ws-projekte/ws-website-2.0/i18n/locales/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/